import createProps from '@kissui/helpers/src/props.helpers'

class CardLabels extends HTMLElement {
    constructor() {
        super()
        this.props = {}
        this.labels = []
    }

    connectedCallback() {
        this.props = createProps(this.attributes)
        this.render()
    }

    render() {
        const { labels = [], direction = 'column' } = this.props
        this.classList.add(`${direction === 'row' ? 'direction-row' : 'direction-' + direction}`)

        if (labels.length === 0) {
            return ''
        }
        this.labels = labels

        this.innerHTML = `${this.renderLabels()}`
    }

    renderLabels() {
        return this.labels
            .map(label => {
                const { name = '', bgColor = '', color = '' } = label
                return `<mark class="t-3xs-500-caps-sl"
                            ${
                                bgColor &&
                                color &&
                                `style="background: ${bgColor}; color: ${color}"`
                            }>
                            <span>${name}</span>
                        </mark>`
            })
            .join('')
    }
}

customElements.get('nb-card-labels') || customElements.define('nb-card-labels', CardLabels)

export default CardLabels
